module.exports = __webpack_public_path__ + "img/mpe1.06e73708.png";